import React from "react";
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import "./styles.css";
import { shuffledPhotos as photos } from "./data";

export default function App() {
  const [selected, setSelected] = React.useState(null);

  return (
    <AnimateSharedLayout type="crossfade">
      <div className="container">
        {photos.map((photo) => {
          return (
            <Thumbnail id={photo.id} key={photo.id} setSelected={setSelected} />
          );
        })}
      </div>

      <AnimatePresence>
        {selected && (
          <DetailView
            selected={selected}
            onClose={() => {
              setSelected(null);
            }}
          />
        )}
      </AnimatePresence>
    </AnimateSharedLayout>
  );
}

function Thumbnail(props) {
  // Preloading the bigger version
  React.useEffect(() => {
    const img = new Image();
    img.src =
      `url('https://images.unsplash.com/` +
      `photo-${props.id}` +
      `?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9` +
      `&fm=jpg` +
      `&w=${500}` +
      `&h=${281}` +
      `&fit=crop&crop=edges')`;
  }, []);

  return (
    <motion.div
      className="thumbnail"
      layoutId={props.id}
      style={{
        backgroundImage:
          `url('https://images.unsplash.com/` +
          `photo-${props.id}` +
          `?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9` +
          `&fm=jpg` +
          `&w=${102}` +
          `&h=${57}` +
          `&fit=crop&crop=edges')`,
        borderRadius: 10
      }}
      onTap={() => {
        props.setSelected(props.id);
      }}
    />
  );
}

function DetailView(props) {
  const { building, location, wiki } = photos.find(
    (photo) => photo.id === props.selected
  );

  return (
    <>
      <motion.div
        className="overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ delay: 0.15 }}
        onTap={props.onClose}
      />

      <motion.div
        className="photo"
        layoutId={props.selected}
        style={{
          backgroundImage:
            `url('https://images.unsplash.com/` +
            `photo-${props.selected}` +
            `?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9` +
            `&fm=jpg` +
            `&w=${500}` +
            `&h=${281}` +
            `&fit=crop&crop=edges')`,
          borderRadius: 10
        }}
        // transition={{ duration: 2 }}
        onTap={props.onClose}
      >
        <p className="building">
          <a href={wiki} target="_blank" rel="noopener noreferrer">
            {building}
          </a>
        </p>
        <p className="location">{location}</p>
      </motion.div>
    </>
  );
}
